<mat-sidenav-container class="app-container">
    <mat-sidenav #sidenav mode="side" 
    [class.mat-elevation-z4]="true" class="app-sidenav" 
    [(opened)]="opened" opened 
    style="width: 269px !important;">
        <mat-nav-list>
            <div fxFlex fxLayout="row" fxLayoutAlign="center center" style="height: 55px; margin-left: 25px;">
                <mat-icon style="margin-bottom: -4px; margin-top: 17px;">dashboard</mat-icon>
                <mat-label style="margin-left: 5px; font-size: 23px; font-family: system-ui;"> RxOrders</mat-label>
            </div>



            <mat-expansion-panel [class.mat-elevation-z0]="true" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')"
            [expanded]=true>

            
                <mat-expansion-panel-header>
                <!-- <section class="sidenav-section"> -->

                    <mat-icon class="custom-icon"><span
                        class="material-symbols-outlined">
                        receipt icon
                    </span></mat-icon>
                    <mat-label class="custom-label-header" style="line-height: 1.4;">Transaction</mat-label>


                <!-- </section> -->
                </mat-expansion-panel-header>


                <mat-nav-list>
                    <a mat-list-item class="nav-tab" routerLink="/searchtransaction" [ngClass]="{'active': isActive('/searchtransaction')}" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')">
                            <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span
                                class="material-symbols-outlined">
                                search
                            </span></mat-icon>
                        <mat-label class="custom-label">Transaction Search</mat-label>
                    </a>                   
                </mat-nav-list>



            </mat-expansion-panel>



            <mat-expansion-panel [class.mat-elevation-z0]="true" 
            [expanded]=true *ngIf="isUserAuthorized('RXORDERS-VELA-IMPLEMENTATION,RXORDERS-VELA-SUPPORT')">
                <mat-expansion-panel-header>
                    <mat-icon class="custom-icon" style="line-height: 1.4;"><span
                        class="material-symbols-outlined">
                        <!-- settings icon -->
                        account_balance
                    </span></mat-icon>
                    <mat-label class="custom-label-header">Pharmacy Config</mat-label>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item class="nav-tab" routerLink="/searchpharmacy" [ngClass]="{'active': isActive('/searchpharmacy')}" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')">
                        <!-- <mat-icon class="custom-icon" style="width: 28px;"><span class="material-symbols-outlined"> -->
                            <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span class="material-symbols-outlined">
                                search
                            </span></mat-icon>
                        <mat-label class="custom-label">Pharmacy Chain Search</mat-label>
                    </a>
                    <a mat-list-item class="nav-tab" routerLink="/addpharmacy" [ngClass]="{'active': isActive('/addpharmacy')}" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')">
                        <!-- <mat-icon class="custom-icon" style="height: 22px; width: 28px"><span -->
                            <mat-icon class="custom-icon"><span
                                class="material-symbols-outlined">
                                medical_services
                            </span></mat-icon>
                        <mat-label class="custom-label">Add Pharmacy Chain</mat-label>
                    </a>
                    <a mat-list-item class="nav-tab" routerLink="/searchpharmacystore" [ngClass]="{'active': isActive('/searchpharmacystore')}" *ngIf="isUserAuthorized('RXORDERS-VELA-IMPLEMENTATION,RXORDERS-VELA-SUPPORT')">
                            <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span class="material-symbols-outlined">
                                search
                            </span></mat-icon>
                        <mat-label class="custom-label">Pharmacy Store Search</mat-label>
                    </a>
                    <a mat-list-item class="nav-tab" routerLink="/searchpharmacystoresync" [ngClass]="{'active': isActive('/searchpharmacystoresync')}" *ngIf="isUserAuthorized('RXORDERS-VELA-IMPLEMENTATION,RXORDERS-VELA-SUPPORT')">
                        <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span class="material-symbols-outlined">
                            search
                        </span></mat-icon>
                        <mat-label class="custom-label">Directory Sync Search</mat-label>
                    </a>
                </mat-nav-list>







            </mat-expansion-panel>
            <mat-expansion-panel [class.mat-elevation-z0]="true" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')"
            [expanded]=true>
                <mat-expansion-panel-header>
                    <mat-icon class="custom-icon"><span
                        class="material-symbols-outlined">
                        token
                    </span></mat-icon>
                    <mat-label class="custom-label-header" style="line-height: 1.4;">Vendor</mat-label>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item class="nav-tab" routerLink="/searchvendor" [ngClass]="{'active': isActive('/searchvendor')}" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')">
                            <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span class="material-symbols-outlined">
                                search
                            </span></mat-icon>
                        <mat-label class="custom-label">Search Vendor</mat-label>
                    </a>
                    <a mat-list-item class="nav-tab" routerLink="/addvendor" [ngClass]="{'active': isActive('/addvendor')}" *ngIf="isUserAuthorized('RXORDERS-VELA-SUPPORT')">
                            <mat-icon class="custom-icon" style="line-height: 1.8 !important;"><span
                                class="material-symbols-outlined">
                                medical_services
                            </span></mat-icon>
                        <mat-label class="custom-label">Add Vendor</mat-label>
                    </a>                   
                </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel [class.mat-elevation-z0]="true" style="display:none">
                <mat-expansion-panel-header>
                    User Managment
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item routerLink="/searchuser">
                        <mat-icon class="custom-icon"><span class="material-symbols-outlined">
                                manage_accounts
                            </span></mat-icon>
                        <mat-label class="custom-label">
                            Users</mat-label>
                    </a>
                    <a mat-list-item routerLink="/searchrole">
                        <mat-icon class="custom-icon" style="width: 29px;"><span class="material-symbols-outlined">
                                group
                            </span></mat-icon>
                        <mat-label class="custom-label">Roles</mat-label>
                    </a>
                    <a mat-list-item routerLink="/userroles">
                        <mat-icon class="custom-icon" style="width: 29px;"><span class="material-symbols-outlined">
                                record_voice_over
                            </span></mat-icon>
                        <mat-label class="custom-label">User Roles</mat-label>
                    </a>
                    <a mat-list-item routerLink="/rolepermissions">
                        <mat-icon class="custom-icon" style="width: 29px; height: 21px;"><span
                                class="material-symbols-outlined">
                                admin_panel_settings
                            </span></mat-icon>
                        <mat-label class="custom-label">Role Security</mat-label>
                    </a>
                </mat-nav-list>
            </mat-expansion-panel>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="custom-content-default" id="mat_sidenav_content">
        <router-outlet>
            <div class="app-sidenav-content">
            </div>
        </router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>